<div *ngIf="!isMd">
    <div class="p-d-flex p-ai-center p-jc-center p-m-4">
      <!-- {{ "Search.Common.TotalRecords" | translate }}
      <font class="count">{{ totalRecords }}</font>
      {{ "Search.Common.Records" | translate }} -->
      <!-- / -->

      {{ "Search.Common.TotalPages" | translate }}
      <font class="count">
        {{ totalPages[totalPages.length - 1]  }}
      </font>
      {{ "Search.Common.Pages" | translate }}
    </div>

    <div class="p-d-flex p-m-2">
      <div class="p-d-flex p-ai-center p-jc-end w-100">
        <font class="p-pr-3">
          {{ "Common.Paginator.CurrentPageCount" | translate }}
        </font>
      </div>
      <div class="p-d-flex p-ai-center p-jc-start w-100">
        <p-dropdown
          [options]="totalPages"
          [(ngModel)]="miniCurrentPage"
          (onChange)="miniSearch()"
          [style]="{'minWidth':'75.44px'}"
        ></p-dropdown>
      </div>
    </div>
    <div class="p-d-flex p-m-2">
      <div class="p-d-flex p-ai-center p-jc-end w-100">
        <font class="p-pr-3">
          {{ "Common.Paginator.RowPerPage" | translate }}
        </font>
      </div>
      <div class="p-d-flex p-ai-center p-jc-start w-100">
        <p-dropdown
        [options]="pagesRows"
        [(ngModel)]="limit"
        (onChange)="miniSearch()"
        [style]="{'minWidth':'75.44px'}"
      ></p-dropdown>
      </div>
    </div>
  </div>
